import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RixtremaDialogComponent } from '../rixtrema-dialog/rixtrema-dialog.component';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-rixtrema-lookup',
  templateUrl: './rixtrema-lookup.component.html',
  styleUrls: ['./rixtrema-lookup.component.scss'],
  imports: [MatIconModule, CommonModule, MatButtonModule],
})
export class RixtremaLookupComponent implements OnInit {
  private dialog = inject(MatDialog);
  private ss = inject(SessionStorageService);

  @Input() fieldData;
  @Input() type;
  @Input() buttonType;
  buttonLabel: string;

  buttonColor;

  ngOnInit(): void {
    this.buttonLabel =
      this.fieldData.props?.options?.find(opt => opt.value === '2')?.label ||
      'Search For Plan';
    this.buttonColor =
      this.fieldData.type === 'custom-manual-lookup-document'
        ? 'primary'
        : 'accent';
  }

  startSession() {
    this.openLookUpDialog({});
  }

  openLookUpDialog(data) {
    if (this.fieldData.type === 'custom-manual-lookup-document') {
      this.fieldData.formControl.setValue(2);
    }
    if (
      this.buttonType === 'rixtrema' ||
      this.buttonType === 'search401k' ||
      this.buttonType === 'searchESOP' ||
      this.buttonType === 'search403b' ||
      this.buttonType === 'searchMP' ||
      this.buttonType === 'searchPension'
    ) {
      let planType = 'DC';

      if (this.buttonType === 'searchPension') {
        planType = 'DB';
      }

      data['groupIndex'] = this.fieldData.parent.form.controls.indexOf(
        this.fieldData.form
      );
      data['planType'] = planType;
    }

    data['planType'] = data['planType'] ? data['planType'] : 'DC';
    data['server'] = this.type === 1 ? 'rixtrema' : 'rightbridge';
    data['buttonType'] = this.buttonType;
    data['UnitInfo'] = this.ss.get('globals')?.GlobalsGroup?.UnitInfo;
    this.dialog.open(RixtremaDialogComponent, {
      panelClass: 'rixtrema-dialog',
      data: data,
      minHeight: '60vh',
      width: '90vw',
    });
  }
}
